import React, { useState, useEffect } from 'react';
import './SurveyResponsesSurveyCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function SurveyResponsesSurveyCard({ surveyCollectionItem, selected, onClick }) {
  const { survey } = surveyCollectionItem;

  if (logComponent('SurveyResponsesSurveyCard')) { console.debug('SurveyResponsesSurveyCard rendered'); }


  const handleClick = () => {
    if (logComponent('SurveyResponsesSurveyCard')) { console.debug('SurveyResponsesSurveyCard handleClick'); }
    onClick(surveyCollectionItem);
  }

  return (
    <li className={'Survey-Responses-Survey-Card' + (selected ? ' Survey-Responses-Survey-Card--selected' : '')}>
      <button onClick={handleClick}>
        <p className="Survey-Responses-Survey-Card__name">{`${survey.surveyName}`}</p>
        {
          survey.organizationType === 'Status Solutions' &&

          <div><p className="Survey-Responses-Survey-Card__organization">{`${survey.organizationName}`}</p></div>
        }
        {
          survey.organizationType !== 'Status Solutions' &&

          <div><p className="Survey-Responses-Survey-Card__organization">{`${survey.organizationType} ${survey.organizationName}`}</p></div>
        }
      </button>
    </li>
  );
}
